import type { ProgramTemplateProviderId } from '@court-sync/shared';
import { cn } from '@/lib/utils';

/** Initials-only placeholders — do not use official federation logos without written permission. */
export const PROGRAM_TEMPLATE_LOGO_PLACEHOLDERS: Record<
  ProgramTemplateProviderId,
  { label: string; alt: string }
> = {
  tennis_australia: {
    label: 'Australian-style',
    alt: 'Placeholder icon for Australian-style pathway — not an official federation logo',
  },
  usta: {
    label: 'US-style',
    alt: 'Placeholder icon for US-style pathway — not an official federation logo',
  },
  europe_tennis10s: {
    label: 'European Tennis10s-style',
    alt: 'Placeholder icon for European Tennis10s-style pathway — not an official federation logo',
  },
  uk_lta_youth: {
    label: 'UK youth-style',
    alt: 'Placeholder icon for UK youth-style pathway — not an official federation logo',
  },
  pickleball_rating: {
    label: 'Pickleball rating-style',
    alt: 'Placeholder icon for pickleball rating-style pathway — not an official federation logo',
  },
  padel_category: {
    label: 'Padel category-style',
    alt: 'Placeholder icon for padel category-style pathway — not an official federation logo',
  },
};

const TEMPLATE_INITIALS: Record<ProgramTemplateProviderId, string> = {
  tennis_australia: 'AU',
  usta: 'US',
  europe_tennis10s: 'EU',
  uk_lta_youth: 'UK',
  pickleball_rating: 'PB',
  padel_category: 'PD',
};

export function ProgramTemplateLogoPlaceholder({
  providerId,
  className,
}: {
  providerId: ProgramTemplateProviderId;
  className?: string;
}) {
  const meta = PROGRAM_TEMPLATE_LOGO_PLACEHOLDERS[providerId];
  const initials = TEMPLATE_INITIALS[providerId];

  return (
    <div
      className={cn(
        'flex h-14 w-14 shrink-0 items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 text-sm font-bold text-gray-600 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300',
        className
      )}
      title={meta.alt}
      aria-hidden
    >
      {initials}
    </div>
  );
}
